"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPrecedentRefined = void 0;
const buildPrecedentRefined = (precedent, assignees = []) => ({
    ID: precedent.ID,
    metadata: {
        created: precedent.metadata.created,
        updated: precedent.metadata.updated,
    },
    endDate: precedent.endDate,
    exemption: precedent.exemption,
    institutionIdentifier: precedent.institutionIdentifier,
    requiredCredentials: precedent.requiredCredentials,
    specified: precedent.specified,
    startDate: precedent.startDate,
    status: precedent.status,
    unspecified: precedent.unspecified,
    visibility: precedent.visibility,
    subjects: precedent.subjectsAwarded?.values.map((value) => ({ ID: value })) ?? [],
    scope: precedent.scope,
    activated: precedent.activated,
    inactivated: precedent.inactivated,
    rejected: precedent.rejected,
    lock: precedent.lock,
    origin: precedent.origin,
    assignees: assignees.map((assignee) => ({ user: assignee.user, assigned: assignee.assigned })),
    negative: precedent.negative,
});
exports.buildPrecedentRefined = buildPrecedentRefined;
//# sourceMappingURL=PrecedentRefined.js.map